export const numberOfRelatedCoursesForDomains: Record<string, number | undefined> = {
  business: 1095,
  'computer-science': 668,
  health: 471,
  'social-sciences': 401,
  'physical-science-and-engineering': 413,
  'data-science': 425,
  'arts-and-humanities': 338,
  'language-learning': 150,
  'personal-development': 137,
  'information-technology': 145,
  'math-and-logic': 70,
};
